<template>
  <div>
    <v-card class="pa-5  elevation-hb">
      <v-row>
        <v-col>
          <h2><v-icon class="mr-2">mdi-cart-outline</v-icon> Pedidos Waaw</h2>
          <h3></h3>
        </v-col>
        <v-col cols="4">
          <v-text-field
            v-model="search"
            placeholder="Pesquisar"
            outlined
            dense
            append-icon="mdi-magnify"
          ></v-text-field>
        </v-col>
        <v-col cols="2">
          <v-btn block depressed color="primary" :loading="loading" @click="executeOperation(1)">
            Importar Shopify
          </v-btn>
        </v-col>
        <v-col class="text-right" cols="2">
          <v-btn 
            depressed 
            color="primary"
            class="text-center mr-1" 
            :disabled="!filteredOrders.length"
            :dark="filteredOrders.length"
            @click="downloadCSV()" 
            block
          >
            <v-icon small class="mx-2">mdi-magnify</v-icon>
            Exportar CSV
          </v-btn>
        </v-col>
      </v-row>
      <v-divider class="my-3" />
      <v-data-table :items="filteredOrders" :loading="loading" :headers="headers" :search="search" :items-per-page="50">
        <template v-slot:[`header.shopifyStatus`]="{ header }">
          <v-select
            :placeholder="header.text"
            :items="shopifyStatus"
            v-model="shopifyStatusFiltered"
            hide-details
            multiple
            dense
            clearable
          >
            <template v-slot:selection="{ item, index }">
              <v-chip small v-if="index === 0" color="blue darken-1" dark>{{ item }}</v-chip>
              <v-chip small color="blue-grey lighten-4" dark v-if="index === 1">
                +{{ shopifyStatusFiltered.length - 1 }}</v-chip
              >
            </template>
          </v-select>
        </template>

        <template v-slot:[`item.shopifyId`]="{ item }">
          <a
            :href="`https://lojawaaw.myshopify.com/admin/orders/${item.shopifyId}`"
            target="_BLANK"
            v-if="item.shopifyId"
          >
            {{ item.shopifyId }}
          </a>
        </template>

        <template v-slot:[`item.shopifyFinancialStatus`]="{ item }">
          <v-chip label dark :color="getColor(item.shopifyFinancialStatus)" v-if="item.shopifyFinancialStatus">
            {{ item.shopifyFinancialStatus }}
          </v-chip>
        </template>

        <template v-slot:[`item.shopifyStatus`]="{ item }">
          <v-chip label dark :color="getColor(item.shopifyStatus)" v-if="item.shopifyStatus">
            {{ item.shopifyStatus }}
          </v-chip>
        </template>

        <template v-slot:[`item.ihubStatus`]="{ item }">
          <v-chip label dark :color="getColor(item.ihubStatus)" v-if="item.ihubStatus">
            {{ item.ihubStatus }}
          </v-chip>
        </template>

        <template v-slot:[`item.shopifyFulfillmentStatus`]="{ item }">
          <v-chip label dark :color="getColor(item.shopifyFulfillmentStatus)" v-if="item.shopifyFulfillmentStatus">
            {{ item.shopifyFulfillmentStatus }}
          </v-chip>
        </template>

        <template v-slot:[`item.externalOrderId`]="{ item }">
          <a
            :href="`https://status.ondeestameupedido.com/tracking/17359/${item.externalOrderId}`"
            target="_BLANK"
            v-if="item.externalOrderId"
          >
            {{ item.externalOrderId }}
          </a>
        </template>

        <template v-slot:[`item.shippingEstimateDate`]="{ item }">
          {{ item.shippingEstimateDate | moment('subtract', '3 hours') | moment('DD/MM/YYYY') }}
          <span v-if="item.shippingTime" class="caption">
            <i>({{ item.shippingTime }}bd)</i>
          </span>
        </template>

        <template v-slot:[`item.createdAt`]="{ item }">
          <div class="caption">
            <b>Criado em:</b> <br />
            {{ item.createdAt | moment('subtract', '3 hours') | moment('DD/MM/YYYY [às] HH:MM') }} <br />
            <b>Atualizado em</b> <br />
            {{ item.updatedAt | moment('subtract', '3 hours') | moment('DD/MM/YYYY [às] HH:MM') }}
          </div>
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item>
                <v-list-item-title @click="setIhub(item.ihubJson)">
                  Objeto Ihub
                </v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-title @click="setIhub(item.shopifyJson)">
                  Objeto Shopify
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="dialog" width="800">
      <v-card class="pa-5">
        <code>
          <pre>{{ target | pretty }}</pre>
        </code>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { baseWaawUrl } from '@/global'
import * as XLSX from 'xlsx'

export default {
  data: () => ({
    orders: [],
    headers: [
      { text: 'Label', value: 'shopifyLabelId' },
      { text: 'Shopify ID', value: 'shopifyId' },
      { text: 'Stat. Fin. Shopify', value: 'shopifyFinancialStatus' },
      { text: 'Status Shopify', value: 'shopifyStatus', sortable: false },
      { text: 'Status Ihub', value: 'ihubStatus' },
      { text: 'Stat. Fulfillment Shopify', value: 'shopifyFulfillmentStatus' },
      { text: 'Rastreio', value: 'externalOrderId' },
      { text: 'Data estimada', value: 'shippingEstimateDate' },
      { text: 'Criado em', value: 'createdAt' },
      { text: 'Ações', value: 'action' },
      // { text: 'Atualizado em', value: 'updatedAt' },
    ],
    shopifyStatus: ['payment-pending', 'ready-for-handling', 'canceled'],
    shopifyStatusFiltered: [],
    loading: false,
    search: null,
    colors: [
      { status: 'paid', color: 'green' },
      { status: 'pending', color: 'rgb(23 23 23)' },
      { status: 'payment-pending', color: 'rgb(8 51 68)' },
      { status: 'ready-for-handling', color: 'rgb(30 64 175)' },
      { status: 'canceled', color: 'deep-orange darken-' },
      { status: 'handling', color: 'green accent-4' },
      { status: 'restocked', color: 'rgb(194 65 12)' },
      { status: 'dispatched', color: 'rgb(132 204 22)' },
      { status: 'fulfilled', color: 'rgb(22 163 74)' },
      { status: 'complete', color: 'rgb(6 95 70)' },
      { status: 'delivered', color: 'rgb(6 95 70)' },
    ],
    dialog: null,
    target: null,
    // Dois dias laranjas, passou do dia vermelho
  }),
  computed: {
    filteredOrders() {
      if (this.shopifyStatusFiltered.length === 0) {
        return this.orders
      } else {
        return this.orders.filter((el) => {
          return this.shopifyStatusFiltered.includes(el.shopifyStatus)
        })
      }
    },
  },
  methods: {
    async loadData() {
      this.loading = true
      const url = `${baseWaawUrl}/orders`
      this.orders = await axios
        .get(url)
        .then((res) => {
          return res.data
        })
        .catch((err) => {
          console.log(err.message)
          return []
        })
      this.loading = false
    },
    getColor(text) {
      const item = this.colors.find((el) => {
        return text === el.status
      })
      if (item && item.color) {
        return item.color
      } else {
        return '#000000'
      }
    },
    setIhub(text) {
      this.target = text
      this.dialog = true
    },
    async executeOperation(operation) {
      let route = ''
      switch (operation) {
        case 1:
          route = 'schedule/importer'
          break
        case 2:
          route = 'schedule/ihub'
          break
        case 3:
          route = 'schedule/create'
          break
        case 4:
          route = 'schedule/approve'
          break
        case 5:
          route = 'schedule/dispatch'
          break
        case 6:
          route = 'schedule/cancel'
          break
      }
      this.loading = true
      const url = `${baseWaawUrl}/${route}`
      await axios.get(url).catch((err) => {
        console.log(err.message)
        return false
      })
      this.loadData()
      this.loading = false
    },
    downloadCSV() {
      const data = this.filteredOrders
      const xlsx = this.convertArrayOfObjectsToXlsx(data)

      const link = document.createElement('a')

      link.href = 'data:text/xlsx;charset=utf-8,' + encodeURI(xlsx)
      link.click()
    },
    convertArrayOfObjectsToXlsx(data) {
      const xlsxData = data
      const formattedData = xlsxData.map((item) => {
        const { 
          shopifyLabelId, 
          shopifyId,
          shopifyFinancialStatus,
          shopifyStatus,
          ihubStatus,
          shopifyFulfillmentStatus,
          externalOrderId,
          shippingEstimateDate,
          createdAt
        } = item

        return {
          shopifyLabelId,
          shopifyId,
          shopifyFinancialStatus,
          shopifyStatus,
          ihubStatus,
          shopifyFulfillmentStatus, 
          externalOrderId,
          shippingEstimateDate,
          createdAt
        }
      })

      const worksheet = XLSX.utils.json_to_sheet(formattedData)
      const workbook = XLSX.utils.book_new()

      const header = [
        'Label', 
        'Shopify ID', 
        'Stat. Fin. Shopify', 
        'Status Shopify', 
        'Status Ihub', 
        'Stat. Fulfillment Shopify', 
        'Rastreio', 
        'Data estimada', 
        'Criado em'
      ]

      XLSX.utils.sheet_add_aoa(worksheet, [header], { origin: 'A1' })
      const dataRows = XLSX.utils.sheet_to_json(worksheet, { header: 1 })      

      XLSX.utils.sheet_add_json(worksheet, dataRows, {
        skipHeader: true,
        origin: 'A1',
      })

      XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados')

      const excelBuffer = XLSX.writeFileXLSX(workbook, 'pedidos-waaw.xlsx')

      return excelBuffer
    },
  },
  async mounted() {
    await this.loadData()
  },
}
</script>

<style></style>
